/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react'; // eslint-disable-line no-unused-vars
import  PropTypes from 'prop-types';
import styles from './InstallerCompanyEditor.scss';
import BaseReactComponent from '../Util/BaseReactComponent';
import { connect } from 'react-redux';
import baseComponent from '../../decorators/baseComponent';
import reactMixin from 'react-mixin';
import CountryDropDown from '../Util/CountryDropDown';
import ProgressButton from '../ProgressButton';
import Modal, {Footer, Header, Body} from 'react-bootstrap/lib/Modal';
import ChangePasswordModal from '../ChangePasswordModal';
import { Form, ValidatedInput } from 'react-bootstrap-validation';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import {Toggle} from 'material-ui';
import update from 'react-addons-update';
import {getConfig} from "../settings";

@connect(state => ({
  manager: state.zehnder.manager,
  config: getConfig(state)
}))
@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin) class InstallerCompanyEditor extends BaseReactComponent {

    constructor(props) {
        super(props);

        this.state = {};
        this.state.deleteMode = false;
        this.state.passwordChangeMode = false;
    }

    onInstallerCompanyDelete = () => {
        if (this.state.deleteMode) {
            this.props.disableInstallerCompany(this.props.installerCompany);

            this.setState({
                deleteMode: false
            });
        }
    }

    onSubmit = (v) => {
      console.log(v);


        const installerCompanyToSave =  Object.assign({}, this.props.installerCompany, v);

        if(this.props.manager && this.props.manager.country) {
            installerCompanyToSave.country = this.props.manager.country;
        }

        if (installerCompanyToSave.id !== undefined) {
            this.props.updateInstallerCompany(installerCompanyToSave);
        } else {
            this.props.addInstallerCompany(installerCompanyToSave);
        }
    }

    onChange = (type, event) => {
        if (type === 'country') {
          this.props.onEditInstallerCompany(Object.assign({}, this.props.installerCompany, {country: event}));
        }
    }

    componentDidMount() {
        // if (this.props.installerCompany()) {
        //     this.editInstallerCompany(this.props.installerCompany());
        // } else {
        //     this.onAddInstallerCompany();
        // }
    }

    componentWillUpdate(nextProps) {
      // if (nextProps.installerCompany() !== undefined && (this.state.id !== nextProps.installerCompany().id || this.state.editMode !== 'EDIT') && this.props.installerCompany().editMode === 'EDIT') {
      //   this.editInstallerCompany(nextProps.installerCompany());
      //   this.props.installerCompany().editMode = undefined;
      // } else if (nextProps.installerCompany() !== undefined && this.props.installerCompany().editMode === 'NEW') {
      //   this.onAddInstallerCompany();
      //   this.props.installerCompany().editMode = undefined;
      // }
    }

    cancelEdit = () => {
        this.props.changeTab(0);
    }

    startDeleteMode = () => {
        this.setState({
            deleteMode: true
        });
    }

    stopDeleteMode = () => {
        this.setState({
            deleteMode: false
        });
    }

    keyup = (e) => {
        if (e.which === 13) {
            this.onInstallerCompanyAdd(e);
        }
    }

    handleChange = (key, event) => {
      let newValue = {};
      newValue[key] = event.currentTarget.value;
      let newState = update(this.state, {$merge: newValue});
      this.setState(newState);
    }

    onToggle = (event, value) => {
      let i = Object.assign({}, this.props.installerCompany, {
          beta: value
      });
      this.props.onEditInstallerCompany(i);
    }

    changePassword = () => {
        this.setState({
            passwordChangeMode: true
        });
    }

    stopChangePassword = () => {
        this.setState({
            passwordChangeMode: false
        });
    }

    render() {
      if (this.props.installerCompany === undefined) {
        return <div/>;
      }
        let subTitle = this.getMessage(this.props.installerCompany.id !== undefined ? 'edit-installer-company' : 'add-installer-company');

        let deleteField = (
            <div className="form-group">
                <label htmlFor="address" className="col-sm-2 control-label">{this.getMessage('delete-label')}</label>

                <div className="col-sm-6">
                    <ProgressButton onClick={this.startDeleteMode}>{this.getMessage('delete-label')} </ProgressButton>
                </div>
            </div>
        );

        let changePasswordButton = (
            <div className="form-group">
                <label htmlFor="address" className="col-sm-2 control-label">{this.getIntlMessage('changepasswordpage.change-password-label')}</label>

                <div className="col-sm-6">
                    <ProgressButton onClick={this.changePassword}>{this.getIntlMessage('changepasswordpage.change-password-label')} </ProgressButton>
                </div>
            </div>
        );

        let countryLabel = (<div className="form-group">
          <label htmlFor="country" className="col-sm-2 control-label">{this.getMessage('country-label')}</label>

          <div className="col-sm-6">
            <CountryDropDown className="validate form-control" id="country" onChange={this.onChange} edit={true} country={this.props.installerCompany.country}/>
          </div>
        </div>);

        return (
            <div className="InstallerCompanyEditor">
                <div className="editor-header">
                    <div className="container">
                        <h1>{subTitle}</h1>
                    </div>
                </div>

                <Modal title="Delete user" onHide={this.stopDeleteMode} show={this.state.deleteMode}>
                    <Header>
                        {this.getMessage('delete-title')}
                    </Header>

                    <Body>
                        <p>
                          {this.getMessage('you-are-about-to-delete')}
                          <b>{this.props.installerCompany.username}</b><br/>
                          {this.getMessage('sure')}
                        </p>
                    </Body>

                    <Footer>
                        <a className="btn btn-link" onClick={this.stopDeleteMode}>{this.getMessage('cancel-button')}</a>
                        <a className="btn btn-primary" onClick={this.onInstallerCompanyDelete}>{this.getMessage('delete-label')}</a>
                    </Footer>
                </Modal>

                <ChangePasswordModal user={this.props.installerCompany} onHide={this.stopChangePassword} show={this.state.passwordChangeMode}/>

                <div className="container">
                    <Form role="form" className="form-horizontal" onKeyPress={this.keyup} onValidSubmit={this.onSubmit}>
                        <div className="form-group">
                            <label htmlFor="companyName" className="col-sm-2 control-label">{this.getMessage('companyName-label')}</label>

                            <div className="col-sm-6">
                                <ValidatedInput name="companyName"
                                                type="text"
                                                className="validate"
                                                id="username"
                                                validate="required"
                                                defaultValue={this.props.installerCompany.id === undefined ? '' :this.props.installerCompany.companyName}
                                                errorHelp={{
                                  required: this.getMessage('empty-ic-name')
                                }}
                                    />
                            </div>
                        </div>

                        <div className="form-group">
                            <label htmlFor="username" className="col-sm-2 control-label">{this.getMessage('username-label')}</label>

                            <div className="col-sm-6">
                                <ValidatedInput name="username"
                                                type="text"
                                                defaultValue={this.props.installerCompany.id === undefined ? '' :this.props.installerCompany.username}
                                                className="validate"
                                                id="username"
                                                validate="required"
                                                errorHelp={{
                                  required: this.getMessage('empty-ic-name')
                                }}
                                    />
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="email" className="col-sm-2 control-label">{this.getMessage('email-label')}</label>

                            <div className="col-sm-6">
                                <ValidatedInput name="email"
                                                type="text"
                                                defaultValue={this.props.installerCompany.id === undefined ? '' : this.props.installerCompany.email}
                                                className="validate"
                                                id="email"
                                                validate="isEmail"
                                                errorHelp={{
                                  isEmail: this.getMessage('invalid-email')
                                }}
                                    />
                            </div>
                        </div>

                      {this.props.installerCompany.id === undefined &&
                      <div className="form-group">
                        <label htmlFor="emailconfirm" className="col-sm-2 control-label">{this.getMessage('email-confirm-label')}</label>

                        <div className="col-sm-6">
                          <ValidatedInput name="email-confirm"
                                          type="text"
                                          className="validate"
                                          id="email-confirm"
                                          validate={(val, context) => {
                                            return val === context.email;
                                          }}
                                          errorHelp={this.getMessage('email-confirm-incorrect')}
                          />
                        </div>
                      </div>
                      }
                        <div className="form-group">
                            <label htmlFor="address" className="col-sm-2 control-label">{this.getMessage('address-label')}</label>

                            <div className="col-sm-6">
                                <ValidatedInput name="address"
                                  defaultValue={this.props.installerCompany.id === undefined ? '' :this.props.installerCompany.address}
                                  type="text"
                                  className="validate"
                                  id="address" />
                            </div>
                        </div>
                      {this.props.manager && !this.props.manager.country? countryLabel : <div></div>}

                      { this.props.config.supportsBeta &&
                        <div className="form-group">
                          <label htmlFor="name" className="col-sm-2 control-label">{this.getMessage('beta-label')}</label>

                          <div className="col-sm-6" style={{paddingTop: '7px'}} >
                            <Toggle onToggle={this.onToggle} toggled={this.props.installerCompany.beta}/>
                          </div>
                        </div> }
                        {this.props.installerCompany.id !== undefined ? deleteField : (<div></div>)}
                        {this.props.installerCompany.id !== undefined ? changePasswordButton : (<div></div>)}
                        <div className="controls">
                            <button className="btn btn-primary">{this.getMessage('save-button')}</button>
                            <a className="btn btn-link" onClick={this.cancelEdit}>{this.getMessage('cancel-button')}</a>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

InstallerCompanyEditor.propTypes = {
    installerCompany: React.PropTypes.object,
    changeTab: React.PropTypes.func,
    updateInstallerCompany: React.PropTypes.func,
    addInstallerCompany: React.PropTypes.func,
    disableInstallerCompany: React.PropTypes.func
};

InstallerCompanyEditor.defaultProps = {
    componentName: 'installer-company-editor'
};

export default InstallerCompanyEditor;



// WEBPACK FOOTER //
// /src/components/InstallerCompanyEditor/InstallerCompanyEditor.js